// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-index-byob-card-tsx": function componentSrcPagesIndexByobCardTsx() {
    return import("./../../src/pages/index/BYOBCard.tsx"
    /* webpackChunkName: "component---src-pages-index-byob-card-tsx" */
    );
  },
  "component---src-pages-index-byob-tsx": function componentSrcPagesIndexByobTsx() {
    return import("./../../src/pages/index/BYOB.tsx"
    /* webpackChunkName: "component---src-pages-index-byob-tsx" */
    );
  },
  "component---src-pages-index-feature-tsx": function componentSrcPagesIndexFeatureTsx() {
    return import("./../../src/pages/index/Feature.tsx"
    /* webpackChunkName: "component---src-pages-index-feature-tsx" */
    );
  },
  "component---src-pages-index-get-invitation-tsx": function componentSrcPagesIndexGetInvitationTsx() {
    return import("./../../src/pages/index/GetInvitation.tsx"
    /* webpackChunkName: "component---src-pages-index-get-invitation-tsx" */
    );
  },
  "component---src-pages-index-hero-tsx": function componentSrcPagesIndexHeroTsx() {
    return import("./../../src/pages/index/Hero.tsx"
    /* webpackChunkName: "component---src-pages-index-hero-tsx" */
    );
  },
  "component---src-pages-index-millions-tsx": function componentSrcPagesIndexMillionsTsx() {
    return import("./../../src/pages/index/Millions.tsx"
    /* webpackChunkName: "component---src-pages-index-millions-tsx" */
    );
  },
  "component---src-pages-index-page-tsx": function componentSrcPagesIndexPageTsx() {
    return import("./../../src/pages/index/Page.tsx"
    /* webpackChunkName: "component---src-pages-index-page-tsx" */
    );
  },
  "component---src-pages-index-ts": function componentSrcPagesIndexTs() {
    return import("./../../src/pages/index.ts"
    /* webpackChunkName: "component---src-pages-index-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-1-ts": function componentSrcPagesPortfolioAnalyser1Ts() {
    return import("./../../src/pages/portfolio-analyser-1.ts"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-1-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-2-ts": function componentSrcPagesPortfolioAnalyser2Ts() {
    return import("./../../src/pages/portfolio-analyser-2.ts"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-2-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-3-ts": function componentSrcPagesPortfolioAnalyser3Ts() {
    return import("./../../src/pages/portfolio-analyser-3.ts"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-3-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-4-ts": function componentSrcPagesPortfolioAnalyser4Ts() {
    return import("./../../src/pages/portfolio-analyser-4.ts"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-4-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-email-report-tsx": function componentSrcPagesPortfolioAnalyserEmailReportTsx() {
    return import("./../../src/pages/portfolio-analyser/email-report.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-email-report-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-mobile-tsx": function componentSrcPagesPortfolioAnalyserMobileTsx() {
    return import("./../../src/pages/portfolio-analyser/mobile.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-mobile-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-page-1-tsx": function componentSrcPagesPortfolioAnalyserPage1Tsx() {
    return import("./../../src/pages/portfolio-analyser/Page1.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-page-1-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-page-2-tsx": function componentSrcPagesPortfolioAnalyserPage2Tsx() {
    return import("./../../src/pages/portfolio-analyser/Page2.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-page-2-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-page-3-tsx": function componentSrcPagesPortfolioAnalyserPage3Tsx() {
    return import("./../../src/pages/portfolio-analyser/Page3.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-page-3-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-page-4-tsx": function componentSrcPagesPortfolioAnalyserPage4Tsx() {
    return import("./../../src/pages/portfolio-analyser/Page4.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-page-4-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-page-tsx": function componentSrcPagesPortfolioAnalyserPageTsx() {
    return import("./../../src/pages/portfolio-analyser/Page.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-page-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-report-tsx": function componentSrcPagesPortfolioAnalyserReportTsx() {
    return import("./../../src/pages/portfolio-analyser/report.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-report-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-thank-you-tsx": function componentSrcPagesPortfolioAnalyserThankYouTsx() {
    return import("./../../src/pages/portfolio-analyser/thank-you.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-thank-you-tsx" */
    );
  },
  "component---src-pages-portfolio-analyser-ts": function componentSrcPagesPortfolioAnalyserTs() {
    return import("./../../src/pages/portfolio-analyser.ts"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-ts" */
    );
  },
  "component---src-pages-portfolio-analyser-underline-tsx": function componentSrcPagesPortfolioAnalyserUnderlineTsx() {
    return import("./../../src/pages/portfolio-analyser/Underline.tsx"
    /* webpackChunkName: "component---src-pages-portfolio-analyser-underline-tsx" */
    );
  },
  "component---src-pages-quiz-page-tsx": function componentSrcPagesQuizPageTsx() {
    return import("./../../src/pages/quiz/Page.tsx"
    /* webpackChunkName: "component---src-pages-quiz-page-tsx" */
    );
  },
  "component---src-pages-quiz-personality-grid-tsx": function componentSrcPagesQuizPersonalityGridTsx() {
    return import("./../../src/pages/quiz/PersonalityGrid.tsx"
    /* webpackChunkName: "component---src-pages-quiz-personality-grid-tsx" */
    );
  },
  "component---src-pages-quiz-question-tsx": function componentSrcPagesQuizQuestionTsx() {
    return import("./../../src/pages/quiz/Question.tsx"
    /* webpackChunkName: "component---src-pages-quiz-question-tsx" */
    );
  },
  "component---src-pages-quiz-result-email-result-modal-tsx": function componentSrcPagesQuizResultEmailResultModalTsx() {
    return import("./../../src/pages/quiz-result/EmailResultModal.tsx"
    /* webpackChunkName: "component---src-pages-quiz-result-email-result-modal-tsx" */
    );
  },
  "component---src-pages-quiz-result-feedback-modal-tsx": function componentSrcPagesQuizResultFeedbackModalTsx() {
    return import("./../../src/pages/quiz-result/FeedbackModal.tsx"
    /* webpackChunkName: "component---src-pages-quiz-result-feedback-modal-tsx" */
    );
  },
  "component---src-pages-quiz-result-page-tsx": function componentSrcPagesQuizResultPageTsx() {
    return import("./../../src/pages/quiz-result/Page.tsx"
    /* webpackChunkName: "component---src-pages-quiz-result-page-tsx" */
    );
  },
  "component---src-pages-quiz-result-share-result-envelope-tsx": function componentSrcPagesQuizResultShareResultEnvelopeTsx() {
    return import("./../../src/pages/quiz-result/ShareResultEnvelope.tsx"
    /* webpackChunkName: "component---src-pages-quiz-result-share-result-envelope-tsx" */
    );
  },
  "component---src-pages-quiz-result-ts": function componentSrcPagesQuizResultTs() {
    return import("./../../src/pages/quiz-result.ts"
    /* webpackChunkName: "component---src-pages-quiz-result-ts" */
    );
  },
  "component---src-pages-quiz-ts": function componentSrcPagesQuizTs() {
    return import("./../../src/pages/quiz.ts"
    /* webpackChunkName: "component---src-pages-quiz-ts" */
    );
  }
};